import constant from "./component-library409.mjs";
import defineProperty from "./component-library341.mjs";
import identity from "./component-library317.mjs";
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string),
    "writable": true
  });
};
const baseSetToString$1 = baseSetToString;
export {
  baseSetToString$1 as default
};
